import { Component, EventEmitter, Output, inject } from '@angular/core';
import { TranslocoPipe, TranslocoService } from '@jsverse/transloco';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-empty-state',
  standalone: true,
  imports: [TranslocoPipe],
  templateUrl: './empty-state.html',
})
export class EmptyState {
  private readonly i18n = inject(TranslocoService);
  @Output() suggestionSelected = new EventEmitter<string>();

  protected readonly showQuestionSuggestions = environment.showQuestionSuggestions;
  protected readonly suggestions = [
    'suggestions.productStock',
    'suggestions.customerBlocked',
    'suggestions.sheetManufacturing',
    'suggestions.stockBalance',
  ];

  protected selectSuggestion(key: string): void { this.suggestionSelected.emit(this.i18n.translate(key)); }
}
